import { PersianTitlesService } from '../../core/services/persian-titles.service';

export const navbarItems = (persianTitlesService: PersianTitlesService) => [
  {
    id: '0',
    icon: 'lucideHouse',
    name: persianTitlesService.Items.HomePage,
    urlParts: ['/'],
  },
  {
    id: '5',
    name: persianTitlesService.Items.Workshops,
    icon: 'lucideAlbum',
    items: [
      {
        id: 'workshops',
        name: persianTitlesService.Items.CurrentWorkshops,
        urlParts: ['workshops'],
      },
      {
        id: 'held-workshops',
        name: persianTitlesService.Items.HeldWorkshops,
        urlParts: ['held-workshops'],
      },
    ],
  },
  {
    id: '4',
    icon: 'lucideLaptop2',
    name: persianTitlesService.Items.WorkshopsVideo,
    urlParts: ['e-workshops'],
  },
  {
    id: '2',
    icon: 'lucideUser',
    name: persianTitlesService.Items.MyUserInformation,
    urlParts: ['profile', 'edit'],
  },
  {
    id: '3',
    icon: 'lucideListChecks',
    name: persianTitlesService.Items.MyTrainingHistory,
    urlParts: ['profile', 'training-history'],
  },
  {
    id: 'feedback',
    icon: 'lucideLightbulb',
    name: persianTitlesService.Items.SuggestionsAndCriticisms,
    urlParts: ['feedback'],
  },
];
